import { AnalysisFeature } from '../../features/analysis/index.js';

export function AnalysisPage() {
  return <AnalysisFeature />;
}
